export const ERROR_MESSAGES = {
  400: 'Something went wrong. Please try again.',
  401: 'Your session has expired. Please log in again.',
  403: "You don't have permission to perform this action.",
  404: "We couldn't find what you were looking for.",
  409: 'This item already exists or is in use.',
  422: 'Some information seems incorrect. Please re-check and try again.',
  429: "You're doing that too fast. Please wait for a moment.",
  500: 'Something went wrong on our end. Please try again later.',
  502: 'The server is temporarily unavailable. Please try again soon.',
  503: 'Service is temporarily unavailable. Please try again shortly.',
  504: 'The server is taking too long to respond. Please try again.',
};

export const getErrorMessage = (status?: number) => {
  const errorMessage =
    ERROR_MESSAGES[status as keyof typeof ERROR_MESSAGES] ||
    'Unexpected error occurred.';

  return {
    message: errorMessage,
    status: status ?? 500,
  };
};
